<!-- Router of application -->
<div class="keeper" *ngIf="renderApp">
    <router-outlet *ngIf="!isIframe"></router-outlet>
</div>

<!-- Error modal -->
<p-toast position="bottom-right">
    <ng-template let-message pTemplate="message">
        <div>
            <h3>{{message.summary}}</h3>
            <p>{{message.detail}}</p>
        </div>
    </ng-template>
</p-toast>

<!-- Spinner for loading -->
<mapfre-auditlib-spinner></mapfre-auditlib-spinner>

<!-- Generic modal -->
<mapfre-auditlib-modal [(visible)]="visible">
    <div class="content-flow">
        <h2>{{modal?.title | translate}}</h2>
        <span class="me-2">{{modal?.question | translate}}</span>
        <small>{{modal?.subquestion | translate}}</small>
    </div>
    <div class="d-flex justify-content-end">
        <mapfre-auditlib-button class="me-3" (click)="sendResponse(true)">
            <span class="white" translate>FLOW.CONFIRM</span>
        </mapfre-auditlib-button>
        <mapfre-auditlib-button (click)="sendResponse(false)">
            <span class="white" translate>FLOW.CANCEL</span>
        </mapfre-auditlib-button>
    </div>
</mapfre-auditlib-modal>

<!-- Modal for inactivity -->
<mapfre-auditlib-modal [(visible)]="showInactivityModal">
    <div class="content-flow content-flow-inactivity">
        <h2>{{ "INACTIVITY.PERIOD" | translate}}</h2>
        <span class="me-2">{{ "INACTIVITY.WARNING" | translate}}</span>
        <h3 class="text-center">{{timeLeft}}</h3>
    </div>
</mapfre-auditlib-modal>
